import {createListFromObject} from "../../../../Utilities/Types/listUtilities";

export const DISPLAY_STATUS = {
    Enabled: 1,
    Disabled: 2,
}

export function getAvailabilityStatusList() {
    return createListFromObject(DISPLAY_STATUS);
}